import React, { useState } from "react"
import {
  PricingSection,
  PricingHeadingWrapper,
  PricingSubHeading,
  PricingHeading,
  PricingPlanCol,
  PricingPlanImg,
  PricingPlanHeading,
  PricingPlanPrice,
  PricingPlanLine,
  PricingPlanBtn,
  PricingPlanLightText,
  PricingPlanDarkText,
  PricingPlanColCenter,
  PricingPlanBtnCenter,
} from "./pricing.style"
import { Container, Row, Col } from "@bootstrap-styled/v4"
import Fade from "react-reveal/Fade"
import { useStaticQuery, graphql } from "gatsby"
import styles from './pricing.module.css';

const Pricing = () => {
  const JSONData = useStaticQuery(graphql`
    query {
      saasJson {
        Pricing {
          DelayConstant
          PricingHeading
          PricingSubHeading
          PricingPlanCol {
            PricingPlanHeading
            PricingPlanImg
            PricingPlanPrice
            PricingPlanPriceSpan
            PricingPlanPriceAnnual
            PricingPlanPriceSpanAnnual
            PricingPlanDarkText {
              Text
            }
            PricingPlanBtn
          }
        }
      }
    }
  `)

  const [interval, setInterval] = useState({});

  const updateInterval = (pricingName, intervalName) => {
    console.log("interval", interval);
    var newInterval = {...interval};
    newInterval[pricingName] = intervalName;
    console.log(newInterval);
    setInterval(newInterval);
  }

  const renderPricingTable = () => {
    return JSONData.saasJson.Pricing.PricingPlanCol.map(pricing => {
      return (
        <Col key={pricing.PricingPlanHeading} md="4" style={{ marginLeft: "auto", marginRight: "auto" }}>
          <Fade
            bottom
            delay={(2 + 1) * JSONData.saasJson.Pricing.DelayConstant}
          >
            <PricingPlanCol>
              <PricingPlanHeading>
                {pricing.PricingPlanHeading}
              </PricingPlanHeading>
              {/* <PricingPlanImg src={pricing.PricingPlanImg} alt="" /> */}
              <PricingPlanPrice>
                {(interval[pricing.PricingPlanHeading] === "Monthly" ?  pricing.PricingPlanPrice : pricing.PricingPlanPriceAnnual)}
                <div style={{ fontSize: "20px" }}>
                </div>
              </PricingPlanPrice>
              {/* <PricingPlanPrice>
                {pricing.PricingPlanPriceAnnual}{" "}
                <div style={{ fontSize: "20px" }}>
                  {pricing.PricingPlanPriceSpanAnnual}
                </div>
              </PricingPlanPrice> */}

              <div className={styles.paymentTrigger}>
                <div 
                    onClick={() => updateInterval(pricing.PricingPlanHeading, "Monthly")}
                className={`${styles.paymentButton} ${interval[pricing.PricingPlanHeading] === "Monthly" && styles.current}`}>
                  <div>Paid Monthly</div>
                </div>
                <div 
                onClick={() => updateInterval(pricing.PricingPlanHeading, "Yearly")}
                className={`${styles.paymentButton} ${interval[pricing.PricingPlanHeading] !== "Monthly" && styles.current}`}>
                  <div>Paid Annually</div>
                </div>
              </div>

              <PricingPlanLine />
              {pricing.PricingPlanDarkText.map((itemDark, idxDark) => {
                return (
                  <PricingPlanDarkText key={idxDark}>
                    {itemDark.Text}
                  </PricingPlanDarkText>
                )
              })}
              <PricingPlanBtn href="https://admin.dockeeper.io/register">
                {pricing.PricingPlanBtn}
              </PricingPlanBtn>
            </PricingPlanCol>
          </Fade>
        </Col>
      )
    })
  }

  return (
    <PricingSection id="pricingContainer">
      <Container>
        <Row>
          <Col md="12">
            <PricingHeadingWrapper>
              <Fade bottom delay={1 * JSONData.saasJson.Pricing.DelayConstant}>
                <PricingHeading>
                  {JSONData.saasJson.Pricing.PricingHeading}
                </PricingHeading>
              </Fade>
              <Fade bottom delay={2 * JSONData.saasJson.Pricing.DelayConstant}>
                <PricingSubHeading>
                  Need a custom package?{" "}
                  <a href="#contactContainer">Contact us</a>
                </PricingSubHeading>
              </Fade>
            </PricingHeadingWrapper>
          </Col>
        </Row>

        <Row>
          {renderPricingTable()}
          {/* <Col md="4" style={{ marginLeft: "auto", marginRight: "auto" }}>
                        <Fade bottom delay={(2 + 1) * JSONData.saasJson.Pricing.DelayConstant}>
                            <PricingPlanCol>
                                <PricingPlanHeading>{JSONData.saasJson.Pricing.PricingPlanCol[2].PricingPlanHeading}</PricingPlanHeading>
                                <PricingPlanImg src={JSONData.saasJson.Pricing.PricingPlanCol[2].PricingPlanImg} alt="" />
                                <PricingPlanPrice>{JSONData.saasJson.Pricing.PricingPlanCol[2].PricingPlanPrice} / <span>{JSONData.saasJson.Pricing.PricingPlanCol[2].PricingPlanPriceSpan}</span></PricingPlanPrice>
                                <PricingPlanLine />
                                {
                                    JSONData.saasJson.Pricing.PricingPlanCol[2].PricingPlanDarkText.map((itemDark, idxDark) => {
                                        return <PricingPlanDarkText key={idxDark}>{itemDark.Text}</PricingPlanDarkText>
                                    })
                                }
                                <PricingPlanBtn href="https://admin.dockeeper.io/register">{JSONData.saasJson.Pricing.PricingPlanCol[2].PricingPlanBtn}</PricingPlanBtn>
                            </PricingPlanCol>
                        </Fade>
                    </Col> */}
        </Row>
      </Container>
    </PricingSection>
  )
}

export default Pricing
